import { forwardRef } from 'react';
import { useLoadMedia } from '@storefront/lib-global/hooks/useLoadMedia';

type ProductMediaVideoProps = {
  videoUrl: string;
  hasControls?: boolean;
  autoPlay?: boolean;
  observerOptions?: IntersectionObserverInit;
};

export const ProductMediaVideo = forwardRef<HTMLVideoElement, ProductMediaVideoProps>(
  ({ videoUrl, hasControls, autoPlay, observerOptions }, ref) => {
    const mp4Url = `${videoUrl}/mp4_720p`;
    const webmUrl = `${videoUrl}/webm_720p`;

    const { mediaRef } = useLoadMedia(mp4Url, webmUrl, observerOptions);

    return (
      <video
        height="100%"
        width="100%"
        controls={hasControls}
        autoPlay={autoPlay}
        muted
        crossOrigin="anonymous"
        playsInline
        ref={(node) => {
          if (typeof ref === 'function') {
            mediaRef(node);
            ref(node);
          }
        }}
        preload="none"
      />
    );
  },
);

export default ProductMediaVideo;
